module.exports = __webpack_public_path__ + "img/vector.23154ff3.svg";